import React, { useEffect, useRef } from 'react'
import { finalRank, shorten } from '../../utils/filters'
import Flag from '../common/Flag'

export default function TrainingTable({ results, current }) {
  const highlightedRowRef = useRef(null)
  const scrolledBibsRef = useRef(new Set())
  
  const isHighlighted = (row) => {
    return current && String(current.bib) === String(row.bib)
  }
  
  useEffect(() => {
    if (highlightedRowRef.current && current) {
      const bib = String(current.bib)
      if (!scrolledBibsRef.current.has(bib)) {
        scrolledBibsRef.current.add(bib)
        highlightedRowRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }
  }, [current])

  if (!results || results.length === 0) {
    return <p>No results available</p>
  }

  // Check which training rounds have data
  const hasLength1 = results.some(r => r.length1)
  const hasLength2 = results.some(r => r.length2)
  const hasLength3 = results.some(r => r.length3)
  const hasLength4 = results.some(r => r.length4)

  return (
    <table className="resultstable" cellSpacing="0" cellPadding="0" width="100%">
      <thead>
        <tr>
          <th className="text-center">Rank</th>
          <th className="text-center hidden md:table-cell">Bib</th>
          <th>Name</th>
          <th>Nat.</th>
          {hasLength1 && <th className="text-center">Dist.1</th>}
          {hasLength2 && <th className="text-center">Dist.2</th>}
          {hasLength3 && <th className="text-center">Dist.3</th>}
          {hasLength4 && <th className="text-center">Dist.4</th>}
        </tr>
      </thead>
      <tbody>
        {results.map((row, index) => (
          <tr 
            key={index}
            ref={isHighlighted(row) ? highlightedRowRef : null}
            className={`${index % 2 === 0 ? 'even' : 'odd'} ${isHighlighted(row) ? 'highlight' : ''}`}
          >
            <td className="text-center">{finalRank(row)}</td>
            <td className="text-center hidden md:table-cell">{row.bib}</td>
            <td>
              <span className="hidden md:inline">{row.name}</span>
              <span className="md:hidden">{shorten(row.name)}</span>
            </td>
            <td>
              <Flag code={row.nation} />
            </td>
            {hasLength1 && (
              <td className="text-center">
                {row.length1 ? (typeof row.length1 === 'number' ? row.length1.toFixed(1) : parseFloat(row.length1).toFixed(1)) : '-'}
              </td>
            )}
            {hasLength2 && (
              <td className="text-center">
                {row.length2 ? (typeof row.length2 === 'number' ? row.length2.toFixed(1) : parseFloat(row.length2).toFixed(1)) : '-'}
              </td>
            )}
            {hasLength3 && (
              <td className="text-center">
                {row.length3 ? (typeof row.length3 === 'number' ? row.length3.toFixed(1) : parseFloat(row.length3).toFixed(1)) : '-'}
              </td>
            )}
            {hasLength4 && (
              <td className="text-center">
                {row.length4 ? (typeof row.length4 === 'number' ? row.length4.toFixed(1) : parseFloat(row.length4).toFixed(1)) : '-'}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
